import {
    LOAD_METRICS_FOR_CLUSTER_CALL_BEGIN,
    LOAD_INDUCT_PACKAGE_METRICS_FOR_CLUSTER,
    LOAD_STOW_ASSOCIATE_METRICS_FOR_CLUSTER,
    LOAD_STOW_PACKAGE_METRICS_FOR_CLUSTER,
    LOAD_METRICS_FOR_CLUSTER_CALL_FAILURE,
    LOAD_STOW_PACKAGE_METRICS_FOR_NODE,
    LOAD_INDUCT_PACKAGE_METRICS_FOR_NODE,
    LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE,
    LOAD_STOW_BIN_METRICS_FOR_CLUSTER,
    LOAD_STOW_BIN_METRICS_FOR_NODE,
    LOAD_STOW_CART_METRICS_FOR_CLUSTER, LOAD_STOW_CART_METRICS_FOR_NODE
} from "../actions/ClusterActions";

/**
 * Initial state of the system.
 */

const initialState = {
    loading: false,
    stowPackageMetricsMap: {},
    stowBinMetricsMap: {},
    stowCartMetricsMap: {},
    inductPackageMetricsMap: {},
    stowAssociateMetricsMap: {},
    totalStowPackageMetrics: {},
    totalStowBinMetrics: {},
    totalInductPackageMetrics: {},
    totalStowAssociateMetrics: {}
}

/**
 * Reducer function for Cluster View that changes state
 * based on the action triggered.
 */
export default function clusterReducer(state = initialState, action) {
    switch (action.type) {
        case LOAD_METRICS_FOR_CLUSTER_CALL_BEGIN:
            return {
                ...state,
                loading: true
            }
        case LOAD_STOW_PACKAGE_METRICS_FOR_CLUSTER:
            return {
                ...state,
                loading: false,
                stowPackageMetricsMap: action.stowPackageMetricsMap
            };
        case LOAD_STOW_BIN_METRICS_FOR_CLUSTER:
            return {
                ...state,
                loading: false,
                stowBinMetricsMap: action.stowBinMetricsMap
            };
        case LOAD_STOW_CART_METRICS_FOR_CLUSTER:
            return {
                ...state,
                loading: false,
                stowCartMetricsMap: action.stowCartMetricsMap
            };
        case LOAD_STOW_CART_METRICS_FOR_NODE:
            return {
                ...state,
                loading: false,
                stowCartMetricsMap: {"Total": {...state.stowCartMetricsMap["Total"], ...action.stowCartMetricsMap["Total"]}}
            };
        case LOAD_INDUCT_PACKAGE_METRICS_FOR_CLUSTER:
            return {
                ...state,
                loading: false,
                inductPackageMetricsMap: action.inductPackageMetricsMap
            };
        case LOAD_STOW_ASSOCIATE_METRICS_FOR_CLUSTER:
            return {
                ...state,
                loading: false,
                stowAssociateMetricsMap: action.stowAssociateMetricsMap
            };
        case LOAD_STOW_PACKAGE_METRICS_FOR_NODE:
            return {
                ...state,
                loading: false,
                totalStowPackageMetrics: {"Total": {...state.totalStowPackageMetrics["Total"], ...action.totalStowPackageMetrics["Total"]}}
            }
        case LOAD_STOW_BIN_METRICS_FOR_NODE:
            return {
                ...state,
                loading: false,
                totalStowBinMetrics: action.totalStowBinMetrics
            }
        case LOAD_INDUCT_PACKAGE_METRICS_FOR_NODE:
            return {
                ...state,
                loading: false,
                totalInductPackageMetrics: action.totalInductPackageMetrics
            }
        case LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE:
            return {
                ...state,
                loading: false,
                totalStowAssociateMetrics: action.totalStowAssociateMetrics
            }
        case LOAD_METRICS_FOR_CLUSTER_CALL_FAILURE:
            return {
                ...state,
                loading: false
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/ClusterReducer.js